import React from 'react';
import { Box, Typography } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import OpenLockIcon from '@mui/icons-material/LockOpenOutlined';
import ClosedLockIcon from '@mui/icons-material/LockOutlined';

const styles = theme => ({
  root: {
    marginLeft: 'auto',
    marginRight: 20,
    marginTop: 70,
  },
  lock: {
    color: '#BEBEBE',
    marginTop: 5,
  },
  startDate: {
    fontSize: 12,
    color: '#9AA6AC',
  },
  pointsContainer: {
    marginTop: 5,
    background:
      'linear-gradient(180deg, rgba(250,210,190,1) 0%, rgba(255,171,157,1) 100%)',
    color: '#fff',
    borderRadius: '50%',
    width: 21,
    height: 21,
  },
  points: {
    fontWeight: 'bold',
  },
});

const PointsLock = ({
  classes,
  startDate,
  startDateDistance,
  locked,
  finished,
  credits,
}) => {
  return (
    <Box
      className={classes.root}
      display="flex"
      alignItems="flex-end"
      flexDirection="column">
      {finished ? (
        <>
          <Typography variant="caption" className={classes.startDate}>
            Vor {startDateDistance} Tagen
          </Typography>
          <Box
            className={classes.pointsContainer}
            display="flex"
            justifyContent="center"
            alignItems="center">
            <Typography variant="caption" className={classes.points}>
              {credits}
            </Typography>
          </Box>
        </>
      ) : (
        <>
          <Typography variant="caption" className={classes.startDate}>
            {startDate}
          </Typography>
          {locked ? (
            <ClosedLockIcon className={classes.lock} />
          ) : (
            <OpenLockIcon className={classes.lock} />
          )}
        </>
      )}
    </Box>
  );
};

export default withStyles(styles)(PointsLock);
